import React from 'react';
import PropertyStatisticsView from './PropertyStatisticsView'; // Import the new reusable component
import './PropertyStatsModal.css';

const PropertyStatsModal = ({ searchCriteria, onClose, onPropertySelect }) => {
  const handlePropertyRowClick = (property) => {
    if (onPropertySelect) {
      onPropertySelect(property);
    }
    onClose(); // Close the modal after selecting a property
  };

  return (
    <div className="stats-modal-overlay">
      <div className="stats-modal-container">
        <div className="stats-modal-header">
          <h2>My Properties Statistics</h2>
          <button onClick={onClose} className="stats-modal-close-btn">
            &times;
          </button>
        </div>
        <div className="stats-modal-content">
          <PropertyStatisticsView searchCriteria={searchCriteria} onPropertySelect={handlePropertyRowClick} />
        </div>
      </div>
    </div>
  );
};

export default PropertyStatsModal;
